// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"17d2e467","89":"5c2483c5","195":"5ea82afa","205":"bb848160","274":"b46c3cdc","353":"e12688cb","546":"75843d38","678":"33eb4dd5","744":"3130605f","885":"7589ca0a","963":"adab9585"}[chunkId] + ".chunk.js";
};